import type { Recording } from '@hotjar/webapp/features/Playbacks/types';
import { SimilarRecordingsFilterOptions } from '../constants';
import { transformBrowserNameToBrowserType } from './transformBrowserNameToBrowserType';
import { transformOSNameToOSType } from './transformOSNameToOSType';
import type { SimilarRecordingsFilterOption } from '../types';
import { sanitizeUUID } from '../../../../../lib/sanitize';

export const getRecordingValueForOption = (
  option: SimilarRecordingsFilterOption,
  recording: Recording,
): string | false => {
  if (!recording[option]) return false;
  if (option === SimilarRecordingsFilterOptions.BROWSER) {
    return transformBrowserNameToBrowserType(recording[option] as string) as string;
  }

  if (option === SimilarRecordingsFilterOptions.OS) {
    return transformOSNameToOSType(recording[option] as string) as string;
  }

  if (option === SimilarRecordingsFilterOptions.USER_ID) {
    return sanitizeUUID(recording[option] as string) as string;
  }

  return recording[option] as string;
};
